import React, { forwardRef, ReactNode } from 'react';
import {
  SimpleGrid as ChakraSimpleGrid,
  SimpleGridProps,
} from '@chakra-ui/react';

interface Props extends Omit<SimpleGridProps, `css`> {
  children: ReactNode;
}

export const Grid = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraSimpleGrid ref={ref} {...props}>
        {children}
      </ChakraSimpleGrid>
    );
  }
);
export type { Props as GridProps };
